import React, { useRef, useLayoutEffect, useState } from "react";
import { QuizyUrl,TempUrl } from "../../libs/env";
import Collapse from "@kunukn/react-collapse";
import { Button } from "reactstrap";

export const getDomainUrl = () => `${window.location.origin}`;

const QuestionDescription = ({description, showBtn,isReview, hide_border, data, ImageToggle }) => {
  const targetRef = useRef();
  let class_name = ""
  const [isOpen, setIsOpen] = useState(isReview);
  const [dimensions, setDimensions] = useState({
    actualHeight: 0,
  });
  let params = new URL(document.location).searchParams;
  let edit_template = params.get("edit_template");
  let bg_color = "#2f56a1";
  let fsize = "fs-6";
  let btnsize ="";
  if (window.location.origin.includes(QuizyUrl)) {
    bg_color = "#1C49D0 ";
  }
  useLayoutEffect(() => {
    if (isReview) {
      setIsOpen(!isOpen);
    }
    setInterval(function(){
      if (targetRef.current) {
        setDimensions({
          width: targetRef.current.offsetWidth,
          height: targetRef.current.offsetHeight,
          actualHeight: targetRef.current.getClientRects()[0]["height"],
        });
      }
    },500);
  }, [isReview]);

  const toggle = (index) => {
    setIsOpen(!isOpen);
  };
  if (description.props.dangerouslySetInnerHTML.__html){
     class_name ="py-3"
  }
  if(edit_template === "true" || window.location.pathname.includes(TempUrl)){
    // class_name = "pt-2";
    // fsize = "preview_fsize";
    // btnsize = "preview_fsize py-0 px-1";
  }
  return (
   
    <div className="app">
      <Collapse
        isOpen={!isOpen}
        collapseHeight="77px"
        className= {` ${class_name} app__collapse`}
        render={(collapseState) => (
          <div
            ref={targetRef}
            className={!isOpen ? "" : "app__content"}
            onClick={() => (isOpen ? toggle() : null)}
          >
            <h2 className={`${fsize} mb-0 example-size`}>
              {data && data?.content_img &&(
                <div> <img class="ms-3 rounded-5" style={{float: "right"}} onClick={() => ImageToggle()} src={data?.content_img} width="27%"  alt="content_image" /> </div>
              )}
             {description}
            </h2>
          </div>
        )}
      />
      <div className="text-end pt-2">
        {showBtn && dimensions.actualHeight > 70 ? (
          <>
          <Button
            size="sm"
            className={`no-download ${btnsize}`}
            onClick={() => toggle()}
            style={{
              backgroundColor: `${bg_color}`,
              color: "white",
              marginBottom: "3px",
            }}
          >
            {isOpen ? (
              <div>
                {/* <img src={`${imageURl}/arrowdown.png`} alt="" /> */}
                Expand
              </div>
            ) : (
              <div>
                {/* <img src={`${imageURl}/arrowup.png`} alt="" /> */}
                Collapse
              </div>
            )}
          </Button>
          { hide_border && hide_border === "true" ? null:( <p className="pt-2 quiz-bottom-border"></p> )}
         </>
        ) : null}
        { !showBtn && description.props.dangerouslySetInnerHTML.__html ?( <p className="pt-2 quiz-bottom-border"></p> ):null}
      </div>
    </div>
  );
};

export default QuestionDescription;
